export default "__VITE_ASSET__DI910mzh__"